<template>
  <div class="tags">
    <div class="item lifetime">
      <span class="line"></span>
      <div class="text">
        <div>
          <span class="name">
            Lifetime Earnings
          </span>
          <span class="num"> {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalLifetimeEarnings)?.toFixed(2)
            }}</span>
        </div>
        <div>
          <svg class="icon artmisads-select-down-icon" aria-hidden="true">
            <use xlink:href="#icon-dollar-circle"></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="tags-bottom">
      <div class="tags-bottom-left">
        <div class="item open" style="background-color: rgba(255, 255, 255, 0);">
          <div class="line"></div>
          <div class="text">
            <div>
              <div class="name">
                Open Earnings
              </div>
              <div class="num"> {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalOpenEarnings)?.toFixed(2) }}</div>
            </div>
            <div>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jindu-cu"></use>
              </svg>
            </div>
          </div>
        </div>
        <div class="item-bottom">
          <div class="item-bottom-left">
            <div class="item-bottom-title">
              Attribution
            </div>
            <div class="item-bottom-content">
              {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalAttributionOpenEarnings)?.toFixed(2) }}
            </div>
          </div>
          <div class="item-bottom-right">
             <div class="item-bottom-title">
                Associate
            </div>
            <div class="item-bottom-content">
               {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalAssociateOpenEarnings)?.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
      <div class="tags-bottom-right">
        <div class="item commission" style="background-color: rgba(255, 255, 255, 0);">
          <div class="line"></div>
          <div class="text">
            <div>
              <div class="name">
               Settled Earnings
              </div>
              <div class="num"> {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalSettledEarnings)?.toFixed(2) }}</div>
            </div>
            <div>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-a-Frame1912057384"></use>
              </svg>
            </div>
          </div>
        </div>
        <div class="item-bottom">
          <div class="item-bottom-left">
            <div class="item-bottom-title">
              Awaiting Brand Payment
            </div>
            <div class="item-bottom-content">
              {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalAwaitingBrandPayment)?.toFixed(2) }}
            </div>
          </div>
          <div class="item-bottom-mid">
             <div class="item-bottom-title">
                Scheduled Payment
            </div>
            <div class="item-bottom-content">
               {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalScheduledPayment)?.toFixed(2) }}
            </div>
          </div>
          <div class="item-bottom-right">
             <div class="item-bottom-title">
                ArtemisAds Paid Amount
            </div>
            <div class="item-bottom-content">
               {{ props.billingsAgg?.currencySymbol }}{{ Number(props.billingsAgg?.totalCommissionPaid)?.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
 
</template>
<script setup>
const props = defineProps(['billingsAgg'])
</script>
<style lang="less" scoped>
.icon{
  color: rgba(172, 170, 177, 1);
  fill: rgba(172, 170, 177, 1);
  font-size: 20px;
}
.tags {
  // display: flex;
  margin-top: 16px;

  .item {
    background-color: rgba(80, 64, 128, 0.03);
    border-radius: 8px;
    display: flex;

    padding: 12px 14px 12px 0;

    &:nth-child(n+2) {
      margin-left: 16px;
    }

    .line {
      width: 4px;
      height: 56px;
      opacity: 0.85;
      border-radius: 3px;
    }

    .text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-grow: 1;
      // flex-direction: column;
      flex: 1;
      margin-left: 12px;

      .name {
        font-weight: 500;
        font-size: 13px;
        color:rgba(15, 6, 41, 1);
        letter-spacing: 0.3px;
        line-height: 20px;
        margin-bottom: 9px;
        display: flex;
        justify-content: space-between;

        svg {
          width: 16px;
          height: 16px;
          align-self: center;
        }
      }

      .num {
        color: var(--dark-1);
        font-weight: 600;
        font-size: 20px;
        letter-spacing: 0.5px;
        line-height: 26px;
      }
    }
  }

  .lifetime {
    width: 444px;

    .line {
      background-color: rgba(118, 83, 218, 1);
    }

    // svg {
    //   fill: var(--dark-2);
    // }
  }

  .pending,
  .commission {
    flex: 1;
  }

  .open {
    .line {
      background-color: rgba(246, 175, 70, 1);
    }
  }

  .pending {
    background-color: var(--yellow-3);

    .line {
      background-color: var(--tag-bg-7);
    }

    svg {
      fill: var(--yellow-4);
    }
  }

  .commission {
    .line {
      background-color: var(--green-8);
    }

    // svg {
    //   fill: var(--green-5);
    // }
  }
}
.item-bottom{
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 10px 16px;
  .item-bottom-left{
    flex: 1;
   
  }
  .item-bottom-mid{
    flex: 1;
  }
   .item-bottom-title{
      font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 12px;
leading-trim: NONE;
line-height: 20px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 1);
    }
    .item-bottom-content{
      font-family: Sora;
font-weight: 600;
font-size: 16px;
leading-trim: NONE;
line-height: 26px;
letter-spacing: 0.5px;
color: rgba(15, 6, 41, 1);
    }
  .item-bottom-right{
    flex: 1;
  }
}
.tags-bottom {
  display: flex;
  flex: 1;
  gap: 16px;
  margin-top: 16px;
 
  .tags-bottom-left {
    width: 444px;
    border-radius: 8px;
     background-color: rgba(80, 64, 128, 0.03);
  }

  .tags-bottom-right {
    flex: 1;
    border-radius: 8px;
     background-color: rgba(80, 64, 128, 0.03);
  }
}
</style>